import React from "react";
import SystemLabel from "../system/SystemLabel/SystemLabel";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
export default function NotAuthorized(props) {
    return (
        <div>
            <Dialog
                fullWidth={true}
                maxWidth={'sm'}
                open={true}
                TransitionComponent={Transition}
                keepMounted
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title">{" "}
                    <React.Fragment>
                        <ErrorOutlineIcon />{"  "}
                        <SystemLabel name="NotAuthorized" />
                    </React.Fragment>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        <SystemLabel name="LinkIsNotValid" />
                    </DialogContentText>
                    <DialogContentText id="alert-dialog-slide-description">
                        <SystemLabel name="ContactEventHost" />
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </div>
    )
}
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
